const BASE_TABS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "report", label: "Report" },
  { id: "monitoring", label: "Monitoring" },
];

export default function WorkspaceTabShell({
  activeTab = "dashboard",
  onTabChange,
  extraTabs = [],
  children,
}) {
  const tabs = [...BASE_TABS, ...(Array.isArray(extraTabs) ? extraTabs : [])];
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col">
      <div
        className="flex shrink-0 gap-1 border-b px-4"
        role="tablist"
        aria-label="Workspace views"
        style={{ borderColor: "var(--border)", background: "var(--bg-elevated)" }}
      >
        {tabs.map((tab) => {
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onTabChange?.(tab.id)}
              className="relative px-3 py-2 text-[12px] font-semibold transition-colors"
              style={{
                color: active ? "var(--text-primary)" : "var(--text-dim)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              {tab.label}
              {active ? (
                <span
                  aria-hidden
                  style={{
                    position: "absolute",
                    left: 8,
                    right: 8,
                    bottom: 0,
                    height: 2,
                    borderRadius: 2,
                    background: "var(--accent)",
                  }}
                />
              ) : null}
            </button>
          );
        })}
      </div>
      <div
        role="tabpanel"
        className="min-h-0 min-w-0 flex-1 overflow-y-auto overscroll-y-contain px-4 pb-3 pt-4"
        style={{ scrollbarGutter: "stable" }}
      >
        {children}
      </div>
    </div>
  );
}
